function checkValidity(field) {
	const inputLabel = field.parentElement.querySelector(
		`label[for="${field.id}"]`,
	)
	const isCheckbox = field.type.toLowerCase() === 'checkbox'
	const parentLabel = !inputLabel
		? field.parentElement.tagName.toLowerCase() === 'label'
			? field.parentElement
			: null
		: inputLabel
	const label = inputLabel ? inputLabel : parentLabel ? parentLabel : null
	if (!isCheckbox) {
		if (!field.validity.valid) {
			if (label) label.classList.add('!text-error-red')
			field.classList.add('border', '!border-error-red', '!text-error-red')
		} else {
			field.classList.remove('border', '!border-error-red', '!text-error-red')
			if (label) label.classList.remove('!text-error-red')
			return true
		}
	} else if (isCheckbox) {
		const checkLabel = label.querySelector('span')
		if (!field.validity.valid) checkLabel.classList.add('!text-error-red')
		else checkLabel.classList.remove('!text-error-red')
		return true
	}
	return false
}

const forms = document.querySelectorAll('form')
const checkBoxes = document.querySelectorAll("input[type='checkbox']")

checkBoxes.forEach((checkbox) => {
	const check = document.createElement('span')
	check.innerHTML = `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="min-w-4 min-h-4 hidden">
        <g clip-path="url(#clip0_1170_2716)">
            <path d="M13.3333 0C14.0406 0 14.7189 0.280952 15.219 0.781049C15.719 1.28115 16 1.95942 16 2.66667V13.3333C16 14.0406 15.719 14.7189 15.219 15.219C14.7189 15.719 14.0406 16 13.3333 16H2.66667C1.95942 16 1.28115 15.719 0.781049 15.219C0.280952 14.7189 0 14.0406 0 13.3333V2.66667C0 1.95942 0.280952 1.28115 0.781049 0.781049C1.28115 0.280952 1.95942 0 2.66667 0H13.3333ZM11.9733 4.41778L6.22222 10.1689L4.02667 7.97333C3.90029 7.85557 3.73314 7.79146 3.56042 7.79451C3.38771 7.79756 3.22293 7.86753 3.10078 7.98967C2.97864 8.11181 2.90867 8.2766 2.90562 8.44931C2.90258 8.62203 2.96668 8.78918 3.08444 8.91556L5.75111 11.5822C5.87611 11.7071 6.04556 11.7772 6.22222 11.7772C6.39889 11.7772 6.56833 11.7071 6.69333 11.5822L12.9156 5.36C13.0333 5.23362 13.0974 5.06647 13.0944 4.89376C13.0913 4.72105 13.0214 4.55626 12.8992 4.43411C12.7771 4.31197 12.6123 4.242 12.4396 4.23896C12.2669 4.23591 12.0997 4.30002 11.9733 4.41778Z" fill="#00244E"/>
        </g>
        <defs>
            <clipPath id="clip0_1170_2716">
                <rect width="16" height="16" fill="white"/>
            </clipPath>
        </defs>
    </svg>
    `
	checkbox.insertAdjacentElement('afterend', check.querySelector('svg'))
})

forms.forEach((form) => {
	const textAreas = form.querySelectorAll('textarea')
	const inputs = form.querySelectorAll('input,textarea')

	form.setAttribute('novalidate', 'true')
	inputs.forEach((input) => {
		input.addEventListener('input', function () {
			checkValidity(input)
		})
	})

	textAreas.forEach((textArea) => {
		textArea.addEventListener('input', function () {
			this.style.height = 'auto'
			this.style.height = `${this.scrollHeight + 10}px`
		})
	})

	form.addEventListener('submit', async function (ev) {
		const elementValues = {}
		let isFormValid = true
		const submitButton = form.querySelector("button[type='submit']")
		const postType = form.getAttribute('data-post-type')

		inputs.forEach((input) => {
			const isFieldValid = checkValidity(input)
			if (isFieldValid) {
				elementValues[input.name] = input.value
			}
			isFormValid = isFormValid && isFieldValid
		})
		const contactForm = form?.getAttribute('id')

		if (contactForm === 'contact-form') {
			const captchaResponse = grecaptcha?.getResponse()
			if (!captchaResponse?.length > 0) {
				isFormValid = false
			} else {
				elementValues['g-recaptcha-response'] = captchaResponse
			}
		}
		if (isFormValid) {
			try {
				if (!postType || postType.toLowerCase() === 'json') {
					ev.preventDefault()
					const res = await fetch(form.action, {
						method: 'POST',
						body: JSON.stringify(elementValues),
					})
					if (res) {
						const json = await res.json()
						if (json.status === 'success') {
							form.classList.add('hidden')
							const successMessage = document.createElement('h2')
							successMessage.innerHTML = `<p class="text-galaxy-blue heading-md font-medium">${form.getAttribute(
								'data-success-message',
							)}</p>`
							form.parentElement.appendChild(successMessage)
						}
					}
				}
			} finally {
				submitButton.disabled = false
			}
		} else {
			ev.preventDefault()
		}
	})
})
